import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'

export const useIsPortal = () => {
  const state = useSelector((state: IRootReducerState) => state)
  const isPortal = useMemo(() => state?.shop?.ModulePortalEnabled, [state?.shop?.ModulePortalEnabled])

  return isPortal
}
